import React from 'react';
import './DateNavigator.css';

/**
 * ESPN-style Date Navigator Component
 * Displays a horizontal scrollable date picker with prev/next buttons
 */
function DateNavigator({ selectedDate, onDateChange }) {
  // Generate array of dates (3 days before, today, 6 days after)
  const generateDates = () => {
    const dates = [];
    const today = new Date();

    // Start from 3 days ago
    for (let i = -3; i <= 6; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }

    return dates;
  };

  const dates = generateDates();

  const formatDate = (date) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Check if same day
    const isSameDay = (d1, d2) => {
      return d1.getFullYear() === d2.getFullYear() &&
             d1.getMonth() === d2.getMonth() &&
             d1.getDate() === d2.getDate();
    };

    if (isSameDay(date, today)) {
      return 'Today';
    } else if (isSameDay(date, tomorrow)) {
      return 'Tomorrow';
    } else if (isSameDay(date, yesterday)) {
      return 'Yesterday';
    }

    // Return day of week abbreviation
    return date.toLocaleDateString('en-US', { weekday: 'short' });
  };

  const formatDateNumber = (date) => {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const isSelected = (date) => {
    if (!selectedDate) return false;
    return selectedDate.getFullYear() === date.getFullYear() &&
           selectedDate.getMonth() === date.getMonth() &&
           selectedDate.getDate() === date.getDate();
  };

  const handlePrevDay = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(selectedDate.getDate() - 1);
    onDateChange(newDate);
  };

  const handleNextDay = () => {
    const newDate = new Date(selectedDate);
    newDate.setDate(selectedDate.getDate() + 1);
    onDateChange(newDate);
  };

  return (
    <div className="date-navigator">
      <button className="date-nav-btn prev" onClick={handlePrevDay} aria-label="Previous day">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" />
        </svg>
      </button>

      <div className="date-scroller">
        <div className="date-list">
          {dates.map((date, index) => (
            <button
              key={index}
              className={`date-item ${isSelected(date) ? 'selected' : ''}`}
              onClick={() => onDateChange(date)}
            >
              <div className="date-label">{formatDate(date)}</div>
              <div className="date-number">{formatDateNumber(date)}</div>
            </button>
          ))}
        </div>
      </div>

      <button className="date-nav-btn next" onClick={handleNextDay} aria-label="Next day">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" />
        </svg>
      </button>
    </div>
  );
}

export default DateNavigator;
